import { render, staticRenderFns } from "./RegionalOfficeAlternativeLocationAnalisys.vue?vue&type=template&id=691e5ff8&"
import script from "./RegionalOfficeAlternativeLocationAnalisys.vue?vue&type=script&lang=js&"
export * from "./RegionalOfficeAlternativeLocationAnalisys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports